<template>
    <div :id="`voiceMessagePlayer`" class="sc-message--text" ref="voiceMessage">
        <div class="audio-player-container">
            <div @click="toggleAudio()">
                <md-icon id="playButton">{{ paused ? "play_circle" : "pause_circle" }}</md-icon>
            </div>
            <av-waveform
                id="waveform"
                :playtime="false"
                :playtimeWithMs="false"
                :playtimeTextBottom="false"
                :playtimeSliderWidth="3"
                :noplayedLineColor="'#999999'"
                :played-line-color="'#6098ff'"
                :audio-src="getSrc()"
                :playtimeFontSize="0"
                :canvWidth="200"
                :canvHeight="40"
                :played-line-width="0.3"
                :noplayed-line-width="0.3"
                :playtime-slider-color="'#4E8CFF'"
            ></av-waveform>
        </div>

        <!-- Transkripsiyon Bölümü -->
        <div v-if="data.transcribedText" class="transcription-container">
            <div class="transcription-header" @click="toggleTranscription">
                <span>{{ showTranscription ? "Transkripsiyonu Gizle" : "Transkripsiyonu Göster" }}</span>
                <md-icon>{{ showTranscription ? "expand_less" : "expand_more" }}</md-icon>
            </div>
            <div v-show="showTranscription" class="transcription-text">
                {{ data.transcribedText }}
            </div>
        </div>

        <div v-else class="transcribe-button" @click="requestTranscription">
            <a href="#">Transkripsiyon Yap</a>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
export default {
    name: "VoiceMessage",
    props: ["data"],
    data: () => ({
        paused: true,
        showTranscription: false,
    }),
    computed: {
        ...mapState({
            isDarkMod: (state) => state.app.darkMode,
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        getSrc() {
            const asset = this.data.asset;
            const isWhatsapp = asset.path.indexOf("whatsapp") !== -1;
            const isInstagram = asset.path.indexOf("instagram") !== -1;
            const isMessenger = asset.path.indexOf("messenger") !== -1;
            const isTelegram = asset.path.indexOf("telegram") !== -1;
            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger
                    ? `https://static.supsis.live/${asset.path}`
                    : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
            return src;
        },
        toggleAudio() {
            const audio = this.$refs.voiceMessage.querySelector(`audio`);
            audio[audio?.paused ? "play" : "pause"]();
            this.paused = !this.paused;
        },
        toggleTranscription() {
            this.showTranscription = !this.showTranscription;
        },
        requestTranscription() {
            const conversationId =
                (typeof this.data.conversation === "object" ? this.data.conversation._id : this.data.conversation) ||
                this.data.conversationId;
            sendSocketMessage("user transcribe-audio", {
                siteId: this.siteId,
                conversationId: conversationId,
                uniqMessageId: this.data.uniqMessageId,
                cdnUrl: this.data.asset.cdnUrl,
            });
        },
    },
    watch: {
        data: {
            deep: true,
            handler(newVal) {
                console.log("audio data changed", newVal);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
#voiceMessagePlayer {
    display: flex;
    flex-direction: column;
    padding: 4px;
    background-color: transparent;

    &::after {
        display: none;
    }
}

.audio-player-container {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    i.md-icon {
        font-style: normal !important;
        background-color: none !important;
        padding: 0 !important;
        margin-right: 4px;
        color: #4e8cff;
    }
}

#waveform {
    margin-right: 20px;
    padding: 0 10px 0 20px;
    background-color: #ededed;
    border-radius: 25px;
}

.sc-message--text {
    background-color: transparent;
}

.transcription-container {
    margin-top: 4px;
    width: 100%;
    padding-left: 28px;
}

.transcription-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #666;
    font-size: 0.9em;

    .md-icon {
        font-size: 20px;
        margin-left: 4px;
    }
}

.transcription-text {
    margin-top: 8px;
    padding: 8px;
    background-color: #f5f5f5;
    border-left: 3px solid #ddd;
    color: #666;
    font-size: 0.9em;
    border-radius: 4px;
}

.transcribe-button {
    margin-top: 4px;
    padding-left: 28px;

    a {
        color: #4e8cff;
        text-decoration: none;
        font-size: 0.9em;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
